import Vue from 'vue'
import Vuex from 'vuex'
import authorityMenus from './modules/authorityMenus'
import user from './modules/user'
import global from './modules/global'
import profile from './modules/profile'
import learnTask from './modules/learnTask'
import thesis from './modules/thesis'
Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    authorityMenus,
    user,
    global,
    profile,
    learnTask,
    thesis
  }
})
export default store
